// ChildrenDashboard/index.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import BranchesList from '../../containers/BranchesList';
import ButtonSearchBoxActionBar from '../ButtonSearchBoxActionBar';
import CreateBranchDialog from '../../containers/CreateBranchDialog';

const useStyles = makeStyles((theme) => ({
  actionBar: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

const BranchDashboard = (props) => {
  const {
    searchTerm,
    handleSearchTermChange,
    openCreateBranchDialog,
    loggedInUser
  } = props;
  const classes = useStyles();

  return (
    <React.Fragment>
      <CreateBranchDialog />
      <div className={classes.actionBar}>
        <ButtonSearchBoxActionBar
          openCreateDialog={openCreateBranchDialog}
          searchTerm={searchTerm}
          handleSearchTermChange={handleSearchTermChange}
          buttonText="Create Branch"
          searchPlaceholder="Search Branches"
          hideCreate={loggedInUser.role > 2}
        />
      </div>
      <BranchesList />
    </React.Fragment>
  );
};

BranchDashboard.propTypes = {
  // describe the component's prop types here
};

BranchDashboard.defaultProps = {
  // assign default props to the component here
};

export default BranchDashboard;
